<template>
  <div class="managed-client-details">
    <v-row>
      <v-col>
        <breadcrumb :items="breadcrumbs" />
      </v-col>
    </v-row>
    <div style="height: 28px">
      <v-row>
        <v-col
          sm="12"
          md="6"
        >
          <h3
            v-show="!isLoading"
            class="font-weight-light"
          >
            Some information about <span class="font-weight-medium">{{ client.name }}</span>
          </h3>
          <vue-skeleton-loader
            v-show="isLoading"
            :width="350"
            :height="21"
          />
        </v-col>
      </v-row>
    </div>
    <br>
    <br>
    <v-card>
      <v-card-title>Client Details</v-card-title>
      <v-card-text>
        <v-row>
          <v-col
            cols="12"
            sm="6"
            md="4"
          >
            <div class="detail-label">
              Name
            </div>
            <div class="detail-value">
              <vue-skeleton-loader
                v-show="isLoading"
                :width="150"
                :height="18"
              />
              <span v-show="!isLoading">{{ client.name }}</span>
            </div>
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="4"
          >
            <div class="detail-label">
              Account Number
            </div>
            <div class="detail-value">
              <vue-skeleton-loader
                v-show="isLoading"
                :width="150"
                :height="18"
              />
              <span v-show="!isLoading">{{ client.account_number }}</span>
            </div>
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="4"
          >
            <div class="detail-label">
              Backend URL
            </div>
            <div class="detail-value">
              <vue-skeleton-loader
                v-show="isLoading"
                :width="150"
                :height="18"
              />
              <span v-show="!isLoading">{{ client.backend_url }}</span>
            </div>
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="4"
          >
            <div class="detail-label">
              Outstanding Balance
            </div>
            <div class="detail-value">
              <vue-skeleton-loader
                v-show="isLoadingBalance"
                :width="100"
                :height="18"
              />
              <span v-show="!isLoadingBalance">{{ balance.outstanding_balance | formatCurrencyWithDecimal }}</span>
            </div>
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="4"
          >
            <div class="detail-label">
              Credits
            </div>
            <div class="detail-value">
              <vue-skeleton-loader
                v-show="isLoadingBalance"
                :width="100"
                :height="18"
              />
              <span v-show="!isLoadingBalance">{{ balance.credits | formatCurrencyWithDecimal }}</span>
            </div>
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="4"
          >
            <div class="detail-label">
              Created At
            </div>
            <div class="detail-value">
              <vue-skeleton-loader
                v-show="isLoading"
                :width="150"
                :height="18"
              />
              <span v-show="!isLoading">{{ client.created_at | formatDate }}</span>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <br>
    <payments-table :transaction-url="transactionUrl" />
    <br>
    <invoices-table :managed-client-id="clientId" />
  </div>
</template>
<script>
import axios from 'axios'
import VueSkeletonLoader from 'skeleton-loader-vue'
import BreadCrumb from '@/components/partials/BreadCrumb.vue'
import ManagedClientPaymentsTable from '@/components/tables/ManagedClientPaymentsTable.vue'
import ManagedClientInvoicesTable from '@/components/tables/ManagedClientInvoicesTable.vue'

export default {
  components: {
    breadcrumb: BreadCrumb,
    VueSkeletonLoader,
    'payments-table': ManagedClientPaymentsTable,
    'invoices-table': ManagedClientInvoicesTable,
  },
  data() {
    return {
      clientId: this.$route.params.id,
      client: {},
      isLoading: false,
      isLoadingBalance: false,
      balance: {
        outstanding_balance: '0.00',
        credits: '0.00',
      },
      breadcrumbs: [
        {
          text: 'Dashboard',
          disabled: false,
          to: { name: 'dashboard' },
        },
        {
          text: 'Managed Clients',
          disabled: false,
          to: { name: 'managed-clients' },
        },
        {
          text: 'Client Details',
          disabled: true,
        },
      ],
    }
  },
  computed: {
    transactionUrl() {
      return `managed-client-payments?managed_client_id=${this.clientId}&`
    },
  },
  mounted() {
    this.getClientDetails()
    this.getOutstandingBalance()
  },
  methods: {
    getOutstandingBalance() {
      this.isLoadingBalance = true
      axios
        .get(`managed-clients/${this.clientId}/operation-fee-invoices-outstanding-balance`)
        .then(response => {
          this.balance = response.data
          this.isLoadingBalance = false
        })
        .catch(error => {
          this.isLoadingBalance = false
          this.$notification.error(error.response.data.message)
        })
    },
    getClientDetails() {
      this.isLoading = true
      axios
        .get(`managed-clients/${this.clientId}`)
        .then(response => {
          this.client = response.data
          this.isLoading = false
        })
        .catch(error => {
          this.isLoading = false
          this.$notification.error(error.response.data.message)
        })
    },
  },
}
</script>
<style scoped>
.detail-label {
  font-size: 0.75rem;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.6);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
}
.detail-value {
  font-size: 0.95rem;
  color: rgba(0, 0, 0, 0.87);
  min-height: 28px;
  display: flex;
  align-items: center;
}
</style>
